// extracted by mini-css-extract-plugin
export var card = "_82-0";
export var expandedCard = "_82-2";
export var paginated = "_82-1";